import $ from 'jquery'
import { Collapse } from 'bootstrap'

const initializeBlock = function ($block) {
  const opener = $block.find('.tabs__title--desktop')
  const content = $block.find('.tabs__content--desktop')

  opener.on('click', function () {
    opener.removeClass('active')
    $(this).addClass('active')

    const targetId = $(this).attr('data-target')
    const target = $(targetId)

    content.not(target).slideUp(250)
    target.slideDown(250)
  })
}

$('.tabbed-contents-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=smat-tabbed-contents',
    initializeBlock
  )
}
